import React, { useEffect, Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Outlet, useLocation } from 'react-router-dom';
//import Product from './products';
import Header from './header';
import Nav from './nav';
import Footer from './footer';
//import Navigation from './navigation';
//import { GetProduct } from '../utils/product.js';
//import { setProducts } from '../features/productsSlice.js'
// import { addToCart,removFromCart } from '../features/cartSlice.js';}
import { Button, TextField, Grid, Typography, Container, Box } from '@mui/material';
import { GetProduct } from '../utils/product';
import { AppbarContainer, AppbarHeader } from '../styles/headerStyle';
import Banner from './Banner';
import Promotions from './Promotions';
import BannerShopButton from '../styles/banner';
import { SET_LOGGED_PRODUCTINCART } from '../features/productInCartSlice';
import { GetProductsInCartByUserId } from '../utils/productInCart';
import hero1 from "../assets/hero1.png";
import hero2 from "../assets/hero2.png";
import one from "../assets/one.png";
import two from "../assets/two.png";

import HeroCarousel from "./HeroCarousel";
import CategoryGrid from "./CategoryGrid";
import rect1 from "../assets/rect1.png";
import rect2 from "../assets/rect2.png";
import rect3 from "../assets/rect3.png";
import rect4 from "../assets/rect4.png";
import rect5 from "../assets/rect5.png";
import rect6 from "../assets/rect6.png";
import together from "../assets/together.png";
import logo from "../assets/logo.jpg";
import Search from "./Search";
import { GetHomeBanners } from "../utils/homeBanner";


function HomePage() {
    const dispatch = useDispatch();
    // שימוש במשתנה ששמרנו ברידקס - כשהיוזר מתחבר לאתר
    const logedUser = useSelector(state => state.user.logedUser);
    const location = useLocation();
    const [homeImages, setHomeImages] = React.useState([]);

    

    useEffect(() => {
        const fetchBanners = async () => {
            const data = await GetHomeBanners();
           setHomeImages(data.map(x => x.image));
        };

        fetchBanners();
    }, []);

    const hotspots = [
        // שורה עליונה
        { id: "maagal", label: "מעגל השנה", x: 3, y: 12, w: 30, h: 32, to: "/categories/maagal" },
        { id: "arts", label: "חומרי יצירה", x: 35, y: 12, w: 30, h: 32, to: "/categories/arts" },
        { id: "writing", label: "כלי כתיבה", x: 67, y: 12, w: 30, h: 32, to: "/categories/writing" },
        // שורה תחתונה
        //{ id: "deals", label: "מבצעים", x: 3, y: 56, w: 30, h: 32, to: "/categories/deals" },
        { id: "gifts", label: "מתנות ועיצובים", x: 35, y: 56, w: 30, h: 32, to: "/categories/gifts" },
        { id: "games", label: "משחקים", x: 67, y: 56, w: 30, h: 32, to: "/categories/games" },
    ];

    return (
        <>
            <Box sx={{ display: "flex", gap: 3, alignItems: "center", justifyContent: "center" }}>
                <Box sx={{}}>
                    <Box
                        component="img"
                        src={logo}
                        alt="logo"
                        sx={{
                            width: { xs: 30, md: 180 },
                            // height: "auto",
                            pointerEvents: "none", // הלוגו לא יחסום לחיצות
                        }}
                    />
                </Box>
                <Box sx={{ justifySelf: "center" }}>
                    <Nav />
                </Box>
                <Box sx={{}}>
                    <Search fromNavBar={true} />
                </Box>
            </Box>
            <Header />

            <Container maxWidth="xl" sx={{ mt: { xs: 0, md: 0 } }}>
                {/* <AppbarContainer>
                    <AppbarHeader>Welcome to Shine's Stock</AppbarHeader>
                </AppbarContainer> */}
                {/* הצגה של השם שמחובר עכשיו לאתר - מהמשתנה שקיבלנו מהרידקס */}
                {/* {logedUser != null ? <h3> שלום {logedUser.name}, ברוך הבא לשיינ'ס סטוק!</h3> : null} */}
                {logedUser && location.pathname === "/" && (
                    <Box
                        sx={{
                            //   width: "min(1400px, 100%)",
                            //   mx: "auto",
                            px: 10,
                            mt: 2, // רווח קטן מתחת לסרגל
                        }}
                    >
                        <Typography variant="h5" >
                            שלום {logedUser.name}, ברוך הבא לשיינ'ס סטוק!
                        </Typography>
                    </Box>
                )}


                {location.pathname === '/' && (
                    <>

                        {/* {logedUser != null ? <h3> שלום {logedUser.name}, ברוך הבא לשיינ'ס סטוק!</h3> : null} */}
                        {/* <input type="text" placeholder='חיפוש מוצר' />
                        <MyApp /> */}

                        {/* <br /> */}
                        <Promotions />

                        <HeroCarousel
                            images={homeImages.length > 0 ? homeImages : [one, two]}
                            interval={4000}
                            height={500}
                            maxWidth={1300}
                        />

                        <CategoryGrid src={together} hotspots={hotspots} ratio={0.5} maxWidth={1200} />

                        {/* <Banner /> */}
                    </>
                )}

                {/* תגית ששמים אותה כשרוצים לעשות ניווט מקונן - */}
                <Outlet></Outlet>
            </Container>

            <Footer />
        </>
    );

};

export default HomePage;